import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for ForgotPasswordPage
 *
 */

const Otp = lazyLoad(
  () => import('app/modules/Auth/Otp'),
  (module) => module.default,
);

export default Otp;
